/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Meta_HintInputs */

const cs_auth_meta_hint = /** @type {(inputs: Auth_Meta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funguje až po jednorázovém propojení Meta v nastavení profilu.`)
};

const en_auth_meta_hint = /** @type {(inputs: Auth_Meta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works only after you connect Meta once in profile settings.`)
};

/**
* | output |
* | --- |
* | "Works only after you connect Meta once in profile settings." |
*
* @param {Auth_Meta_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_meta_hint = /** @type {((inputs?: Auth_Meta_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Meta_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_meta_hint(inputs)
	return cs_auth_meta_hint(inputs)
});